//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from '@/api/index'
import userApi from '@/api/user'
// import data from '@/api/data'
import testApi from '@/api/test'
import supervisedApi from '@/api/supervised'
import jilinSDK from '@/api/jilinSDK'
import utils from '@/utils'
import Dialog from '@/components/dialog'
import {MessageBox, Toast, Progress, Indicator} from 'mint-ui'
import audio from '@/assets/images/课程学习_音频.png'
import video from '@/assets/images/课程学习_视频.png'
import study from '@/assets/images/课程学习_线下学习.png'
import share from '@/assets/images/课程学习_分享.png'
import menu from '@/assets/images/课程学习_菜单.png'
import menuActive from '@/assets/images/课程学习_菜单_选中.png'
import personIcon from '@/assets/images/personal/个人中心_完善资料_头像.png'
import audioAcitve from '@/assets/images/课程学习_音频_选中.png'
import videoAcitve from '@/assets/images/课程学习_视频_选中.png'
import studyAcitve from '@/assets/images/课程学习_线下学习_选中.png'
import shareAcitve from '@/assets/images/课程学习_分享_选中.png'
import questionAcitve from '@/assets/images/课程学习_答疑_选中.png'
import question from '@/assets/images/课程学习_答疑.png'
import pass from '@/assets/images/pass.png'
import noPass from '@/assets/images/nopass.png'
import personHead from '@//assets/images/底_个人中心_b.png'
import audioJpg from '@/assets/images/audio.jpg'
import audioGif from '@/assets/images/audio.gif'
import wechat from '@/assets/images/wechat.gif'
import wechatCircle from '@/assets/images/wechatCircle.gif'
import qq from '@/assets/images/qq.gif'
import qqSpace from '@/assets/images/qqSpace.gif'
import weibo from '@/assets/images/weibo.gif'
import MtButton from '../../../../node_modules/mint-ui/packages/button/src/button.vue'
import teacherApi from '@/api/teacher'
import idverify4Unit from '@/components/idverify4Unit'
import levitatedSphere from '@/components/levitatedSphere'
import CountDown from 'vue2-countdown'
// import pdf from 'vue-pdf'
import {Const} from '@/consts'
import myBackImg from '@/assets/images/personal/打卡背景.png'
import md5 from 'js-md5'
import more from '../../information/more'
/* import fullscreen from "vue-fullscreen/src/component.vue" */

export default {
  data () {
    return {
      questionNos: [[]],
      endUploadSup: false,
      nodeIndex: -1,
      img: { myBack: myBackImg },
      contentStyleObj: { height: '' },
      messageFont: '',
      isFullscreen: false,
      pdf: {
        pageTotalNum: 1,
        pageRotate: 0,
        // 加载进度
        loadedRatio: 0,
        pageNum: 1,
        loaded: false
      },
      pageStudyDuration: 0,
      levitatedSpherePosition: {
        bottom: '40px',
        left: '100px'
      },
      contentHeight: '',
      allLoaded: false,
      myAnswerList: { pageNo: 0, pageSize: 10, list: [] },
      userId: '',
      myHeadImg: '',
      questionInput: '',
      row: 3,
      introOpen: true,
      popupVisible: false,
      supervisedResult: {},
      supervisedType: '',
      lessonSupervisedInfo: {},
      joinclasscode: 'morenzhi',
      nonTeachingDuration: 0,
      pageStudyDurationUnit: 0,
      newLessonFlag: false,
      completeFlag: false,
      reviewFlag: false,
      isAudio: false,
      playsinline: true,
      randomTestTimeList: [],
      playAble: false,
      activeButton: 'video',
      // examStarted: false,
      currentTime: -1,
      playTimeTemp: 0,
      playBacktime: 0,
      finish: false,
      finishTag: false,
      zhezhao: false,
      isplay: 0,
      lessonid: '',
      testId: '',
      compareFile: '',
      lesson: {},
      logined: false,
      questionList: [],
      questionList2: [],
      questionInfo: {},
      questionInfo2: {},
      progreeId: 0,
      jilinToken: '',
      answer: {},
      audioJpg: audioJpg,
      isAndroid: false,
      myWebsock: null,
      manualSupervisionId: '',
      playerOptions: {
        playbackRates: [], // 播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        bigPlayButton: false,
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'true', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{ type: '', src: '' }], // 你的视频地址（必填）
        poster: audioJpg, // 你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: '此课程暂无法视频', // 许覆盖Video.js无法播���媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          pictureInPictureToggle: false,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: false // 全屏按钮
        }
      },
      questionNo: 0,
      dialogConfig: {
        content: '课程学习完毕,确定要立刻开始章节测试吗?',
        closable: false
      },
      // 这首歌时间有点长 大家测试的时候可以换一个短点的MP3文件
      playflg: false,
      rangeValue: 0,
      starttime: '00:00', // 正在播放时长
      duration: '01:03', // 总时长
      offset: 0,
      limitLearningBySuperTimeOut: 60 * 60 * 1000,
      popupVisiblesc: false
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      // 初始化变量
      this.lessonid = this.$route.query.lessonid
      this.logined = utils.checkUserLogined()
      this.questionList = []
      this.questionList2 = []
      this.answer = []
      this.questionNo = 0
      this.compareFile = this.$route.query.compareFile
      this.contentHeight = window.innerHeight - 320 + 50 + 'px'
      // 获取课程监管信息
      this.getLessonSupervisedInfo().then(resp => {
        // 刷新课程和初始化播放器
        this.initLesson()
        userApi.isCheckLearningLimitDay({ params: {} }).then(resp => {
          if (resp.result.isLearn == 'true') {
            MessageBox.alert(resp.result.msg).then(action => {
              this.$router.push({ path: '/index/courseInfo', query: { courseid: this.$route.query.courseid } })
            })
          }
        }).catch(resp => { })

        if (utils.get('isSupTimeOut') === '1') {
          utils.save('isSupTimeOut', '0')
          userApi.getLimitSuperRecordCount({
            params: {
              progressId: this.progreeId,
              courseId: this.$route.query.courseid,
              targetId: this.$route.query.lessonid,
              mark: 'wap',
              riskType: 'LESSON'
            }
          }).then(resp => {
            var isLearning = resp.result.isLearning
            var limtiCount = resp.result.limtiCount
            console.log('违规学习状态：' + isLearning + ', 免责次数剩余 ： ' + limtiCount)
            if (isLearning && limtiCount) {
              userApi.addLimitSuperRecord({
                params: {
                  progressId: this.progreeId,
                  courseId: this.$route.query.courseid,
                  targetId: this.$route.query.lessonid,
                  mark: 'wap',
                  riskType: 'LESSON'
                }
              }).then(resp => {
                MessageBox.alert('人像识别超时，请点击播放重新识别。').then(action => {
                  utils.save('isSupTimeOut', '0')
                })
              }).catch(resp => {
              })
            } else {
              MessageBox.alert('人脸识别次数超限，本课程学习无法进行学习。').then(action => {
                userApi.resetStudyRecord({
                  params: {
                    progressId: this.progreeId
                  }
                }).then(resp => {
                  this.$router.push({
                    path: '/index/courseInfo',
                    query: {courseid: this.$route.query.courseid}
                  })
                }).catch(resp => {
                })
                utils.save('isSupTimeOut', '0')
              })
            }
          }).catch(resp => {
          })
        }
      })
    })
    this.set_ALY_config()
  },
  created () {
    this.getPhoneMsg()
    this.isAndroid = /android/ig.test(navigator.userAgent)
    if (!utils.checkUserLogined()) {
      utils.save('USER_TYPE', 'TOURIST')// 用户类型-游客
      MessageBox.alert('您还没有登录,现在要登录吗?').then(action => {
        this.$router.push({path: '/login'})
      })
    }/*else{
        this.startLearning()
    }*/
  },
  computed: {
    countDownTime () {
      let now = new Date().getTime()
      let endTime = now + this.nonTeachingDuration
      return {
        startTime: now,
        endTime: endTime
      }
    },
    player () {
      return this.$refs.videoPlayer.player
    },
    menu: function () {
      return this.activeButton === 'menu' ? menuActive : menu
    },
    audio: function () {
      return this.activeButton === 'audio' ? audioAcitve : audio
    },
    video: function () {
      return this.activeButton === 'video' ? videoAcitve : video
    },
    study: function () {
      return this.activeButton === 'study' ? studyAcitve : study
    },
    share: function () {
      return this.activeButton === 'share' ? shareAcitve : share
    },
    question: function () {
      return this.activeButton === 'question' ? questionAcitve : question
    },
    sysPersonHead: function () {
      return personHead
    },
    examDialogConfig: function () {
      var config = {
        title: '随堂测验',
        closable: false
      }
      config.subhead = '第' + (this.questionNo - 0 + 1) + '题/共3题'
      config.confirm = this.hasNext() ? '下一题' : '交卷'
      config.cancel = this.hasLast() ? '上一题' : '退出测试'
      return config
    },
    examDialogConfig2: function () {
      var config = {
        title: '随堂测验',
        closable: false
      }
      config.subhead = ''
      config.confirm = this.hasNext() ? '下一题' : '交卷'
      config.cancel = '退出测试'
      return config
    },
    wechat () {
      return wechat
    },
    wechatCircle () {
      return wechatCircle
    },
    qq () {
      return qq
    },
    qqSpace () {
      return qqSpace
    },
    weibo () {
      return weibo
    },
    personIcon () {
      return personIcon
    },
    intro () {
      var value = this.lesson.content
      if (value) {
        value = '　　' + value
      }
      return value
    }
  },
  components: {
    /* fullscreen, */
    // pdf,
    CountDown,
    idverify4Unit,
    levitatedSphere,
    MtButton,
    myDialog: Dialog,
    examDialog: Dialog,
    examDialog2: Dialog
  },
  methods: {
    // this.lessonSupervisedInfo

    // 上课报到
    courseReport () {
      return jilinSDK.addCourseReport({
        params: {
          schoolId: this.lessonSupervisedInfo.schoolId,
          groupId: this.lessonSupervisedInfo.groupId,
          currlessonId: this.$route.query.lessonid,
          courseId: this.$route.query.courseid
        }
      }).then(resp => {
        this.jilinToken = resp.result
      }).catch((resp) => {
        if (resp.statusCode === '200') {
          // eslint-disable-next-line no-undef
          Toast('吉林数据上报异常[' + resp[Const.RESP_NOTOK_MESSAGE] || Toast(resp[message]) || '获取信息失败' + ']')
        }
      })
    },
    // 课间心跳
    courseAlive () {
      return jilinSDK.addCourseAlive({
        params: {
          token: this.jilinToken,
          lessonId: this.$route.query.lessonid,
          courseId: this.$route.query.courseid
        }
      }).then(resp => {
        this.jilinToken = resp.result
      }).catch((resp) => {
        if (resp.statusCode === '200') {
          // eslint-disable-next-line no-undef
          Toast('吉林数据上报异常[' + resp[Const.RESP_NOTOK_MESSAGE] || Toast(resp[message]) || '获取信息失败' + ']')
        }
      })
    },
    myfunction () {
      let ch = document.documentElement.clientHeight
      if (ch < 400) {
        this.messageFont = '<a style="font-size:10px;">按照当地政策要求，学习过程中需要按照规定进行视频人脸拍照，待身份确定后方可继续。\n' +
                        '请注意个人仪容仪表，保持着装整齐！请保持人脸在镜头内，请勿使用照片或其他辅助工具，以避免学习记录无效！</a>'
      } else {
        this.messageFont = '按照当地政策要求，学习过程中需要按照规定进行视频人脸拍照，待身份确定后方可继续。\n' +
                        '请注意个人仪容仪表，保持着装整齐！请保持人脸在镜头内，请勿使用照片或其他辅助工具，以避免学习记录无效！'
      }
      MessageBox({
        message: this.messageFont,
        title: '温馨提示',
        confirmButtonText: '确定',
        confirmButtonClass: 'button'
      })
    },
    toggle () {
      /* console.log(1111)
                this.$refs['isFullscreen'].toggle(true) */
      this.isFullscreen = true
      this.contentStyleObj.height = window.innerHeight - 70 + 'px'
    },
    // 滑动进度条
    videoHeadInfoDisplayNone () {
      document.getElementById('videoHeadInfo').style.display = 'none'
    },
    videoHeadInfoDisplayInline () {
      document.getElementById('videoHeadInfo').style.display = 'inline'
    },
    // 课件退出全屏
    exitToggle () {
      /* console.log(1111)
                this.$refs['isFullscreen'].toggle(true) */
      this.isFullscreen = false
      this.contentStyleObj.height = ''
    },
    // 课件全屏事件
    fullscreenChange (fullscreen) {
      console.log(fullscreen)
      this.isFullscreen = fullscreen
    },
    // 课件上一页
    prePage () {
      var p = this.pdf.pageNum
      p = p > 1 ? p - 1 : this.pdf.pageTotalNum
      this.pdf.pageNum = p
    },
    // 课件下一页
    nextPage () {
      var p = this.pdf.pageNum
      p = p < this.pdf.pageTotalNum ? p + 1 : 1
      this.pdf.pageNum = p
    },
    clock () {
      this.pdf.pageRotate += 90
    },
    counterClock () {
      this.pdf.pageRotate -= 90
    },
    password (updatePassword, reason) {
      updatePassword(prompt('password is "123456"'))
      console.log('...reason...')
      console.log(reason)
      console.log('...reason...')
    },
    pageLoaded (e) {
      console.log('loaded')
      this.pdf.pageNum = e
      this.pdf.loaded = true
    },
    // pdf文件出错
    pdfError (error) {
      this.pdf.loaded = false
      alert('加载pdf失败：' + error)
      console.error(error)
    },
    // 载入文件头
    loadPdfHandler (e) {
      console.log(e)
      this.pdf.pageNum = 1 // 加载的时候先加载第一页
    },
    // 开始新课程的学习
    startNewLessonLearning () {
      return supervisedApi.startNewLessonLearning({
        params: {
          studyType: this.lesson.stage,
          lessonId: this.$route.query.lessonid
        }
      }).then(resp => {
        this.lessonSupervisedInfo.lessonId = this.lessonid
      }).catch((resp) => {
        console.log(resp)
        if (resp.statusCode === '200') {
          if (resp.message.indexOf('学习时间') > -1) {
            Toast(resp.message || '开始学习失败')
          } else {
            // eslint-disable-next-line no-undef
            Toast('开始学习失败[' + resp[Const.RESP_NOTOK_MESSAGE] || Toast(resp[message]) || '获取信息失败' + ']')
          }
        }
      })
    },
    // 移除已经监管的监管时间
    reviewTimeCountDown () {
      let me = this
      let nonTeachplayTime = 0
      let lastNonTeachplayTime = 0
      // 已经学习时间 总课时时长-视频时长-剩余非教学时长
      nonTeachplayTime = (me.lessonSupervisedInfo.lessonLimitDuration -
                    me.lessonSupervisedInfo.lessonMediaDuration -
                    me.lessonSupervisedInfo.nonTeachingDuration)
      let timeer = setInterval(function () {
        nonTeachplayTime = nonTeachplayTime + 1000
        lastNonTeachplayTime = lastNonTeachplayTime == 0 ? nonTeachplayTime : lastNonTeachplayTime
        if (nonTeachplayTime - lastNonTeachplayTime > 10000) {
          console.log(nonTeachplayTime)
          me.modifyLessonLearningReview(false, nonTeachplayTime)
          lastNonTeachplayTime = nonTeachplayTime
        }
        if (me.$route.path.indexOf('/course/lesson') == -1) {
          clearInterval(timeer)
        }
        if (nonTeachplayTime >= (me.lessonSupervisedInfo.lessonLimitDuration - me.lessonSupervisedInfo.lessonMediaDuration)) {
          clearInterval(timeer)
        }
        if (me.pageStudyDuration > 0) {
          me.pageStudyDuration = me.pageStudyDuration - 1000 > 0 ? me.pageStudyDuration - 1000 : 0
          // 非教学时间是否进行过程监管
          if (me.lessonSupervisedInfo.nonTeachingSuperviseFlag) {
            me.checkPlayTimeSupervised(nonTeachplayTime / 1000)
          }
        } else {
          if (me.pdf.pageNum < me.pdf.pageTotalNum) {
            me.nextPage()
          }
          me.pageStudyDuration = me.pageStudyDurationUnit
        }
      }, 1000)
    },
    // 结束课程预习
    endNonTeachStudyLesson () {
      this.completeFlag = true
      this.modifyLessonLearningReview(true, 111)
      MessageBox({
        title: '',
        message: '亲爱的同学,课程预习结束,开始观看课程视频进行学习吧',
        confirmButtonText: '开始观看视频',
        confirmButtonClass: 'button'
      }).then(action => {
        this.exitToggle()
        this.reviewFlag = false
        this.player.play()
      })
    },
    startLearning (nonTeachingStudyFlag) {
      if (this.newLessonFlag) {
        // 只拉一边题目
        this.newLessonFlag = false
        this.startNewLessonLearning().then(val => {
          if (this.lessonSupervisedInfo.lessonId != 0) {
            if (nonTeachingStudyFlag) {
              this.startNonTeachingStudy()
            }
          } else if (!nonTeachingStudyFlag) {
            this.player.pause()
          }
        }).catch((resp) => {
          console.log(resp)
        })
      } else {
        if (nonTeachingStudyFlag) {
          this.startNonTeachingStudy()
        }
      }
    },
    sendServerLog (str) {
      try {
        userApi.getUserInfo().then(resp => {
          this.userId = resp.result.userid || ''
          testApi.sendJSLogger({
            params: {
              target: this.userId,
              msg: JSON.stringify(str)
            }
          }).then(resp => {
            console.log(resp)
            console.log('sendLogger success!')
          }).catch(resp => {
            console.log(resp)
            console.log('sendLogger error!')
          })
        })
      } catch (e) {
        alert('发送用户终端信息失败：' + e)
      }
    },
    getPhoneMsg () {
      try {
        var device_type = navigator.userAgent // 获取userAgent信息
        testApi.sendJSLogger({
          params: {
            target: this.userId,
            msg: JSON.stringify(device_type)
          }
        }).then(resp => {
          console.log(resp)
          console.log('sendLogger success!')
        }).catch(resp => {
          console.log(resp)
          console.log('sendLogger error!')
        })
      } catch (e) {
        alert('发送用户终端信息失败：' + e)
      }
    },
    onPlayerPause (player) {
    },
    getLessonSupervisedInfo () {
      let params = {
        params: {
          lessonId: this.$route.query.lessonid
        }
      }
      return supervisedApi.getLessonSupervisedInfo(params).then(resp => {
        // 监管信息提示,如进行监管识别，则提示信息
        if (resp.result.beginExamPicture == 'true' ||
                        resp.result.beginStudyPicture == 'true' ||
                        resp.result.learningSuperviseds.length > 0 ||
                        resp.result.regulationNodeList.length > 0 ||
                        resp.result.randomTestTimeList.length > 0
        ) {
          this.myfunction()
        }

        this.lessonSupervisedInfo = resp.result

        this.progreeId = this.lessonSupervisedInfo.progreeId
        this.limitLearningBySuperTimeOut = this.lessonSupervisedInfo.limitLearningBySuperTimeOut
        if (!this.lessonSupervisedInfo.unionTestOpenFlag) {
          this.dialogConfig.content = '当前课时学习已经结束,您要进入下一节课继续学习吗?'
        }
        this.joinclasscode = this.lessonSupervisedInfo.joinClasscode

        if (this.lessonSupervisedInfo.groupId && this.lessonSupervisedInfo.groupId != '0') {
          // if (this.lessonSupervisedInfo.manualSupervisionFlag) {}
          /* this.initWebSocket();
                      window.setInterval(this.websocketonopen, 55000); */
          this.checkCanOnlineStudy4Student()
        }
        console.log('lessonSupervisedInfo', this.lessonSupervisedInfo)
        // 新课程未观看过
        if (this.lessonSupervisedInfo.lessonId == 0) {
          // 本节课进入复习时间提示信息
          this.newLessonFlag = true
        }
        // 有预习时间进入预习时间
        if (this.lessonSupervisedInfo.nonTeachingDuration > 0) {
          let reviewMins = Math.round(this.lessonSupervisedInfo.nonTeachingDuration / 10 / 60) / 100
          MessageBox({
            title: '',
            message: '亲爱的同学,请先根据课件内容进行课前预习,预习时间设定为' + reviewMins + '分钟,仔细阅读课件将有助您更快掌握本节课程知识喔',
            confirmButtonText: '进入课程预习',
            confirmButtonClass: 'button'
          }).then(action => {
            this.startLearning(true)
          })
        }
      }).catch((resp) => {
        if (resp.statusCode === '200') {
          // eslint-disable-next-line no-undef
          // Toast(resp[Const.RESP_NOTOK_MESSAGE] || '获取信息失败')
          MessageBox.alert(resp[Const.RESP_NOTOK_MESSAGE] || '获取信息失败').then(action => {
            this.$router.push({
              path: '/index'
            })
          })
        } else {
          MessageBox.alert(resp[Const.RESP_NOTOK_MESSAGE] || '获取信息失败').then(action => {
            this.$router.push({
              path: '/index'
            })
          })
        }
      })
    },
    startNonTeachingStudy () {
      this.initNonTeachingStudy()
      Indicator.open({
        text: '课件加载中,请耐心等待...',
        spinnerType: 'fading-circle'
      })
      setTimeout(() => {
        this.toggle()
        Indicator.close()
      }, 4000)
    },
    initNonTeachingStudy () {
      this.reviewFlag = true
      this.pageStudyDurationUnit =
                    (this.lessonSupervisedInfo.lessonLimitDuration - this.lessonSupervisedInfo.lessonMediaDuration) /
                    this.pdf.pageTotalNum

      let nonTeachingStudyPass = (this.lessonSupervisedInfo.lessonLimitDuration -
        this.lessonSupervisedInfo.lessonMediaDuration -
        this.lessonSupervisedInfo.nonTeachingDuration) / this.pageStudyDurationUnit
      console.log(nonTeachingStudyPass)

      if (nonTeachingStudyPass == 0) {
        this.pdf.pageNum = 1
        this.pageStudyDuration = this.pageStudyDurationUnit
      } else {
        this.pdf.pageNum = parseInt(nonTeachingStudyPass) == 0 ? 1 : parseInt(nonTeachingStudyPass)
        this.pageStudyDuration = this.pageStudyDurationUnit - (nonTeachingStudyPass - parseInt(nonTeachingStudyPass)) * this.pageStudyDurationUnit
      }
      this.nonTeachingDuration = this.lessonSupervisedInfo.nonTeachingDuration
    },
    modifyLessonLearningReview (completeFlag, playTime) {
      let params = {
        params: {
          completeFlag: this.completeFlag,
          playTime: playTime,
          lessonId: this.lessonid
        }
      }
      console.log('更新课后复习时间')
      supervisedApi.modifyLessonLearningReview(params).then(resp => {
        console.log('更新课后复习时间成功')
      }).catch((resp) => {
        if (resp.statusCode === '200') {
          // eslint-disable-next-line no-undef
          Toast(resp[Const.RESP_NOTOK_MESSAGE] || '获取信息失败')
        }
      })
    },
    submitOnlieManualSupervisionByStudent () {
      let params = {
        params: {
          supervisedFace: this.supervisedResult.compareFile,
          supervisedType: this.supervisedType,
          manualSupervisionId: this.manualSupervisionId,
          lessonId: this.lessonid
        }
      }
      return supervisedApi.submitOnlieManualSupervisionByStudent(params).then(resp => {
        this.supervisedResult.compareFile = ''
        if (resp[Const.RESP_STATUS] == Const.STATUS_OK) {
          if (!this.reviewFlag) {
            this.player.play().then(val => {
              // 重置识别状态，准备下一次识别
              this.supervisedResult.compareResult = false
              this.popupVisible = false
            })
          } else {
            this.supervisedResult.compareResult = false
            this.popupVisible = false
          }
        } else {
          Toast(resp[Const.RESP_NOTOK_MESSAGE] || resp.message || '记录监管结果异常')
        }
      }).catch((resp) => {
        if (resp.statusCode === '200') {
          // eslint-disable-next-line no-undef
          Toast(resp[Const.RESP_NOTOK_MESSAGE] || '获取信息失败')
        }
      })
    },
    submitLessonSupervisedResult () {
      let params = {
        params: {
          supervisedFace: this.supervisedResult.compareFile,
          supervisedType: this.supervisedType,
          lessonId: this.lessonid

        }
      }
      return supervisedApi.submitLessonSupervisedResult(params).then(resp => {
        console.log(resp)
        utils.save('isSupTimeOut', '0')
        this.supervisedResult.compareFile = ''
        if (resp[Const.RESP_STATUS] == Const.STATUS_OK) {
          if (this.endUploadSup) {
            this.goNextLesson()
            this.endUploadSup = false
          }
          let currentSupervisedType = this.supervisedType
          // 更改监管逻辑，三种leaning方式监管方式都一样。
          if (this.supervisedType === 'LEARNING_FACE' ||
                            this.supervisedType === 'LEARNING_BUREA_INTERVAL' ||
                            this.supervisedType === 'LEARNING_BUREA_FIXED' ||
                            this.supervisedType === 'LEARNING_SCHOOL_INTERVAL' ||
                            this.supervisedType === 'LEARNING_SCHOOL_FIXED'
          ) {
            currentSupervisedType = 'LEARNING_FACE'
          }
          switch (currentSupervisedType) {
            case 'LEARNING_FACE':
              this.lessonSupervisedInfo.superviseFaceCounts = this.lessonSupervisedInfo.superviseFaceCounts + 1
              this.removeSupervisedTime()
              if (!this.reviewFlag) {
                this.player.play().then(val => {
                  // 重置识别状态，准备下一次识别
                  this.supervisedResult.compareResult = false
                  this.popupVisible = false
                })
              } else {
                this.supervisedResult.compareResult = false
                this.popupVisible = false
              }
              break
            case 'LEARNING_LEAVE':
              this.lessonSupervisedInfo.superviseLeaveCounts = this.lessonSupervisedInfo.superviseLeaveCounts + 1
              if (!this.reviewFlag) {
                this.player.play().then(val => {
                  // 重置识别状态，准备下一次识别
                  this.supervisedResult.compareResult = false
                })
              } else {
                this.supervisedResult.compareResult = false
              }
              break
            case 'ONEND':
              this.popupVisible = false
              this.goNextLesson()
              break
            case 'ONPLAY':
              this.zhezhao = false
              this.player.play().then(val => {
                // 重置识别状态，准备下一次识别
                this.supervisedResult.compareResult = false
                this.popupVisible = false
              })
              break
            case 'LEARNING_FIXED_REGULATION':
              this.lessonSupervisedInfo.regulationNodeList.splice(this.nodeIndex, 1)
              if (!this.reviewFlag) {
                this.player.play().then(val => {
                  // 重置识别状态，准备下一次识别
                  this.supervisedResult.compareResult = false
                  this.popupVisible = false
                })
              } else {
                this.supervisedResult.compareResult = false
                this.popupVisible = false
              }
              break
            case 'LEARNING_RANDOM_REGULATION':
              this.lessonSupervisedInfo.regulationNodeList.splice(this.nodeIndex, 1)
              if (!this.reviewFlag) {
                this.player.play().then(val => {
                  // 重置识别状态，准备下一次识别
                  this.supervisedResult.compareResult = false
                  this.popupVisible = false
                })
              } else {
                this.supervisedResult.compareResult = false
                this.popupVisible = false
              }
              break
            default:
              break
          }
        } else {
          Toast(resp[Const.RESP_NOTOK_MESSAGE] || resp.message || '记录监管结果异常')
        }
      }).catch((resp) => {
        if (resp.statusCode === '200') {
          // eslint-disable-next-line no-undef
          Toast(resp[Const.RESP_NOTOK_MESSAGE] || '获取信息失败')
        }
      })
    },
    // 去掉已经监管的时间点
    removeSupervisedTime () {
      for (let i = 0; i < this.lessonSupervisedInfo.learningSuperviseds.length; i++) {
        let learningSupervised = this.lessonSupervisedInfo.learningSuperviseds[i]
        // 去掉当前监管规则
        if (this.supervisedType === learningSupervised.supervisedType) {
          let superviseFaceTimeList = learningSupervised.superviseFaceTimes.split(',')
          for (let j = 0; j < superviseFaceTimeList.length; j++) {
            // 去掉已经发生的监管时间，防止下次再进去
            if (parseInt(this.lessonSupervisedInfo.currentSuperviseFaceTime) >= parseInt(superviseFaceTimeList[j])) {
              learningSupervised.superviseFaceTimes =
                                    learningSupervised.superviseFaceTimes.replace(superviseFaceTimeList[j], '')
              console.log(this.lessonSupervisedInfo.learningSuperviseds)
              break
            }
          }
          break
        }
      }
    },
    // 去掉已弹出试题的时间
    removeRandomTestTimeList () {
      for (let i = 0; i < this.randomTestTimeList.length; i++) {
        // 去掉已经发生的监管时间，防止下次再进去 this.lessonSupervisedInfo.randomTestTimeList.split(",")
        if (parseInt(this.playTimeTemp) >= parseInt(this.randomTestTimeList[i] / 1000)) {
          if (this.randomTestTimeList.length === 1) {
            this.lessonSupervisedInfo.randomTestTimeList =
                                this.lessonSupervisedInfo.randomTestTimeList.replace(
                                  this.randomTestTimeList[i], '')
          } else {
            this.lessonSupervisedInfo.randomTestTimeList =
                                this.lessonSupervisedInfo.randomTestTimeList.replace(
                                  this.randomTestTimeList[i] + ',', '')
          }
          this.randomTestTimeList = this.lessonSupervisedInfo.randomTestTimeList.split(',')
          break
        }
      }
    },
    learingSupervised (supervisedType) {
      this.supervisedType = supervisedType
      let currentSupervisedType = this.supervisedType
      // 更改监管逻辑，三种leaning方式监管方式都一样。
      if (this.supervisedType === 'LEARNING_FACE' || this.supervisedType === 'LEARNING_BUREA_INTERVAL' || this.supervisedType === 'LEARNING_BUREA_FIXED' || this.supervisedType === 'LEARNING_SCHOOL_INTERVAL' || this.supervisedType === 'LEARNING_SCHOOL_FIXED') {
        currentSupervisedType = 'LEARNING_FACE'
      }
      switch (currentSupervisedType) {
        case 'LEARNING_FACE':
          console.log('人脸识别：LEARNING_FACE')
          this.supervisedFace()
          break
        case 'LEARNING_LEAVE':
          this.supervisedLeave()
          break
        case 'ONEND':
          if (this.lessonSupervisedInfo.beginExamPicture) {
            console.log('人脸识别：ONEND')
            this.supervisedFace()
          }
          break
        case 'ONPLAY':
          if (this.lessonSupervisedInfo.beginStudyPicture) {
            console.log('人脸识别：ONPLAY')
            localStorage.setItem('beforesupervisedFace', 'true')
            this.supervisedFace()
          } else {
            // 当未开启监管时!this.supervisedResult.compareResult && this.supervisedType.indexOf('LEARNING')===-1为true，会进入此语句，上面语句不能被执行，需要添加下面的语句防止视频无法播放
            this.player.currentTime(this.currentTime)
            this.zhezhao = false
            this.player.play()
          }
          break
        case 'LEARNING_FIXED_REGULATION':
          console.log('人脸识别：LEARNING_FIXED_REGULATION')
          this.supervisedFace()
          break
        case 'LEARNING_RANDOM_REGULATION':
          console.log('人脸识别：LEARNING_RANDOM_REGULATION')
          this.supervisedFace()
          break
        default:
          break
      }
    },
    supervisedLeave () {
      this.player.pause()
      MessageBox.alert('注意眼睛跟屏幕保持合适的距离呦，您调整好了吗?').then(action => {
      })
    },
    supervisedFace () {
      if (this.logined) {
        if (this.supervisedType !== 'ONEND') {
          this.player.pause()
        }
        if (this.supervisedType == 'LEARNING_BUREA_INTERVAL') {
          setTimeout(function () {
            console.log('延迟关闭')
            utils.save('isSupTimeOut', '1')
            // location.reload();
            this.$router.push({
              path: '/index/courseInfo',
              query: {courseid: this.$route.query.courseid}
            })
          }, this.limitLearningBySuperTimeOut)
        }
        console.log('人脸识别：supervisedFace()')
        this.popupVisible = true
      } else {
        utils.save('USER_TYPE', 'TOURIST')// 用户类型-游客
        MessageBox.confirm('您还没有登录,现在要登录吗?').then(action => {
          this.$router.push({path: '/login'})
        })
      }
    },
    supervisedFacePlayEnd () {
      console.log('人脸识别：supervisedFace()')
      this.popupVisible = true
    },
    checkCompareResult (supervisedResult) {
      console.log('shibirtongguo')
      this.joinclasscode = supervisedResult.joinClasscode
      if (!this.finish) {
        // Toast("认证通过！请勿全屏播放，因微信限制，如未自动播放，请手动点击播放！")
        this.popupVisible = false
        this.zhezhao = false
        this.checkPlayTimeSupervisedOning = false
        MessageBox.alert('认证通过！').then(action => {
          this.player.play()
          this.zhezhao = false
        })
      }
      if (this.endUploadSup) {
        this.popupVisible = false
        this.zhezhao = false
        this.checkPlayTimeSupervisedOning = false
      }
      if (supervisedResult.compareResult) {
        this.supervisedResult = supervisedResult
        // 手动监管
        if (this.supervisedType == 'MANUAL_SUPERVISION') {
          this.submitOnlieManualSupervisionByStudent()
        } else {
          this.submitLessonSupervisedResult()
        }
      }
    },
    // 显示通知、注意事项、待完成工作
    getUserMessagelesson () {
      teacherApi.getUserMessage().then(resp => {
        const resultMessage = resp.result
        if (resultMessage.isLive) {
          const usermessage = resultMessage.usermessage
          MessageBox.confirm(usermessage.message, usermessage.title, {
            confirmButtonText: '确定',
            closeOnClickModal: false,
            type: 'info'
          }).then(action => {
            if (usermessage.wapurlOk !== '') {
              this.$router.replace(usermessage.wapurlOk)
            }
          }).catch(() => {
            if (usermessage.wapurlNo !== '') {
              this.$router.replace(usermessage.wapurlNo)
            }
          })
        }
      }).catch((resp) => {
        if (resp.statusCode === '200') {
          // eslint-disable-next-line no-undef
          Toast(resp[Const.RESP_NOTOK_MESSAGE] || '获取信息失败')
        }
      })
    },
    onDateChange (picker, values) {
      if (values[0] > values[1]) {
        picker.setSlotValue(1, values[0])
      }
      this.dateStart = values[0]
      this.dateEnd = values[1]
    },
    next () {
      if (this.hasNext()) {
        console.log(this.questionInfo)
        this.questionNo = this.questionNo + 1
        this.questionInfo = this.questionList[this.questionNo]
        if (this.questionInfo.questiontype = 'MULTISELECT') {
          this.questionNos[this.questionNo] = []
        }
        console.log('当前的答案数据', this.answer)
        console.log(this.questionInfo)
      } else {
        // 中途退出就是交白卷
        this.submit()
      }
    },
    ceshinext () {
      if (typeof (this.answer.as) === 'undefined') {
        MessageBox('提示', '请选择你的答案')
      } else {
        console.log(this.lessonSupervisedInfo.questionListJsonList[3 - this.randomTestTimeList.length].correctOption)
        if (parseInt(this.answer.as) === parseInt(this.lessonSupervisedInfo.questionListJsonList[3 - this.randomTestTimeList.length].correctOption)) {
          this.$refs.examDialog2.close()
          this.player.play()
          testApi.finishExam2({// questionid
            params: {
              lessonid: this.lessonid,
              isok: '1',
              answermap: this.lessonSupervisedInfo.questionListJsonList[3 - this.randomTestTimeList.length].questionid + ',' + this.answer.as
            }
          }).then(resp => {
          }).catch(resp => {
            Toast(resp.message)
          })
          // 去除弹题时间
          this.answer.as = ''
          this.removeRandomTestTimeList()
          if (this.isAndroid) {
            this.zhezhao = false
          }
        } else {
          // Toast('选择错误，请重新选择！');
          MessageBox('提示', '选择错误，请重新选择！')
          this.answer.as = ''
          testApi.finishExam2({
            params: {
              lessonid: this.lessonid,
              isok: '0',
              answermap: this.lessonSupervisedInfo.questionListJsonList[3 - this.randomTestTimeList.length].questionid + ',' + this.answer.as
            }
          }).then(resp => {
          }).catch(resp => {
            Toast(resp.message)
          })
        }
      }
      console.log(this.answer.length)
      console.log(this.answer)
      console.log(this.answer.as)
    },
    hasNext () {
      // 将多选题选项集合整合到单选题选项集合中
      for (let i = 0; i < this.questionNos.length; i++) {
        let moreOptions = this.questionNos[i].join('')
        if (moreOptions != null && moreOptions != '') {
          this.answer[i] = moreOptions
        }
      }
      // end

      if (this.questionNo < 2 && this.questionNo < this.questionList.length - 1 && !utils.isEmptyObject(this.questionList[this.questionNo + 1])) {
        return true
      } else {
        return false
      }
    },
    last () {
      if (this.hasLast()) {
        this.questionNo = this.questionNo - 1
        this.questionInfo = this.questionList[this.questionNo]
        console.log('当前的答案数据', this.answer)
      } else {
        this.routerBack()
      }
    },
    hasLast () {
      if (this.questionNo > 0) {
        return true
      } else {
        return false
      }
    },
    submit () {
      MessageBox.close()
      let answer = {}
      var count = 0
      for (let i in this.answer) {
        if (this.answer[i]) {
          answer[i] = this.answer[i] - 0
          count++
        }
      }
      if (count < 3) {
        MessageBox.alert('存在尚未完成的题目,请继续考试', '确定')
      } else {
        /* 在此处对考试答案记录方式进行优化 start */
        let answer2 = {}
        for (let a in this.answer) {
          answer2[this.questionList[a].questionid + ''] = this.answer[a]
        }
        /* 在此处对考试答案记录方式进行优化 end */

        this.$refs.examDialog.close()
        testApi.finishExam({
          params: {
            testId: this.testId,
            lessonid: this.lessonid,
            answermap: JSON.stringify(answer2)// 此处原传入answer 现传入解析后的答案集合
          }
        }).then(resp => {
          let throughMessage = '<div><div style="font-size: 18px;color: #2766ff;text-align: center;line-height: 36px;height: 36px;">随堂测验</div><div style="width: 100%;height: 1px;background-color: #e0e0e0;"></div><img src="' + pass + '" height="100px" width:"100px" style="margin-top:20px"/><div>测试通过</div></div>'
          let noPassMessage = '<div><div style="font-size: 18px;color: #2766ff;text-align: center;line-height: 36px;height: 36px;">随堂测验</div><div style="width: 100%;height: 1px;background-color: #e0e0e0;"></div><img src="' + noPass + '" height="100px" width:"100px" style="margin-top:20px"/><div>测试不通过</div></div>'
          MessageBox({
            title: '',
            message: resp.result.pass ? throughMessage : noPassMessage,
            confirmButtonText: resp.result.pass ? '返回' : (resp.result.retrytime >= 3 ? '重新学习' : '再次考试'),
            confirmButtonClass: 'button'
          }).then(action => {
            if (resp.result.pass) {
              this.routerBack()
            } else {
              if (resp.result.retrytime >= 3) {
                this.initLesson()
              } else {
                // 如果考试记录为失败状态且考试次数没有超过阈值，则再次开始考试
                this.questionNo = 0
                this.startExam('retry')
                // this.initLesson("retry")
              }
            }
          })
        }).catch(resp => {
          Toast(resp.message)
        })
      }
    },
    async getPlayBacktime () {
      await api.getPlayBacktime({
        params: {
          lessonid: this.lessonid
        }
      }).then(resp => {
        this.currentTime = resp.result.playbacktime / 1000
        this.sendServerLog('vod play page load success ! load vod currtime : ' + this.currentTime)
        return resp.result.playbacktime / 1000
      })
    },
    getLessonAdjustInfoByLoginUser () {
      api.getLessonAdjustInfoByLoginUser({
        params: {
          courseId: this.courseId,
          lessonid: this.lessonid
        }
      }).then(resp => {
        this.currentTime = resp.result.playbacktime / 1000
      })
    },
    initLesson (retry) {
      // 获取章节详情并渲染
      api.getLesson({params: {lessonid: this.lessonid}}).then(resp => {
        this.lesson = resp.result
        console.log("getLesson:"+this.lesson)
        this.duration = (this.lesson.medialength / 1000 / 60).toFixed(2).toString().replace('.', ':')
        if (this.lesson) {
          if (this.lesson.stage === 'CONTINUE') {
            this.getPlayBacktime()
          } else if (this.lesson.stage === 'ADDLEARN') {
            this.getPlayBacktime()
          } else if (this.lesson.stage === 'OVERTIMELEARN') {
            this.getPlayBacktime()
          } else if (this.lesson.stage === 'MISSLEARN') {
            this.getPlayBacktime()
          } else if (this.lesson.stage === 'EXAMINATION') {
            this.finish = true
            this.playAble = false
            if (this.lessonSupervisedInfo.nonTeachingDuration === 0) {
              this.startExam(retry)
            }
          } else if (this.lesson.stage === 'DISABLED') {
            this.routerBack()
          }
        }
        this.sendServerLog('vod play page load success ! load vod currtime : ' + this.currentTime)
        this.initVideoPlayer()
      })
      if (utils.getUserToken()) {
        this.getUserMessagelesson()
        userApi.getUserInfo().then(resp => {
          this.myHeadImg = resp.result.avatarurl || this.sysPersonHead
          this.userId = resp.result.userid || ''
          this.myAnswerList = {pageNo: 0, pageSize: 10, list: []}
          this.getMyAnswerList()
        })
      }
    },
    goBack () {
      this.videoHeadInfoDisplayInline()
      this.routerBack()
    },
    routerBack () {
      this.$router.push({path: '/index/courseInfo', query: {courseid: this.$route.query.courseid}})
    },
    // 同步播放时间
    modifyPlayBacktime: function (playStatus) {
      // eslint-disable-next-line eqeqeq
      if (this.lesson.stage == 'FINISHED') {
          return;

      }

      // 学校归于地区吉林地区则进行上报
      if (this.jilinToken && this.lessonSupervisedInfo.ancestors && this.lessonSupervisedInfo.ancestors.indexOf('0,15276,614456') > -1) {
        this.courseAlive()
      }

      console.log('同步播放时间', this.currentTime)
      let number = Math.round(this.playBacktime * 1000)
      var params = {
        lessonid: this.lessonid,
        playbacktime: number,
        finish: this.finishTag
      }
      // eslint-disable-next-line eqeqeq
      if (playStatus == 'report') {
        params.status = 'beginPlay'
        params.playWay = 'wap'
      }
      params.captchaflag = md5(this.userId + '' + number + this.joinclasscode) + '---' + this.userId + '--' + number + '--' + this.joinclasscode

      // this.finish = true
      try {
        api.modifyPlayBacktime({
          params: params,
          headers: {
            NLoading: '1'
          }
        }).then(resp => {
          var data = resp.result
          console.log('--------')
          if (data.status != 'normal') {
            if (!this.finishTag) {
              console.log('暂停了')
              this.player.pause()
            }
            MessageBox.confirm(data.msg).then(action => {
              switch (data.status) {
                case 'unlogined':
                  this.$router.push({
                    path: '/course/lesson',
                    query: {lessonid: nextLessonId, courseid: this.$route.query.courseid}
                  })
                  break
                case 'playfast':
                  // 异常自动刷新
                  // location.reload()
                  this.$router.push({
                    path: '/course/lesson',
                    query: {lessonid: nextLessonId, courseid: this.$route.query.courseid}
                  })
                  break
                case 'nonsupervision':
                  // 异常自动刷新
                  // location.reload()
                  this.$router.push({
                    path: '/course/lesson',
                    query: {lessonid: nextLessonId, courseid: this.$route.query.courseid}
                  })
                  break
                case 'lackofsupervision':
                  // location.reload()
                  this.$router.push({
                    path: '/course/lesson',
                    query: {lessonid: nextLessonId, courseid: this.$route.query.courseid}
                  })
                  break
                default:
                  break
              }
            })
          } else {
            if (resp.message == '参数校验失败,启用人机交互') {
              this.popupVisiblesc = true
              MessageBox('提示', '为保护您的账号安全，请点击进行智能验证!')
            }
            if (this.finishTag) {
              this.finish = true
              this.finishTag = false
              this.$refs.myDialog.open()
            }
          }
          // 监管部门发布随机监管请求
          if (resp.result != null && resp.result.realTimeShoot != null && resp.result.realTimeShoot == 'open') {
            this.learingSupervised('LEARNING_RANDOM_REGULATION')
          }
        }).catch((resp) => {
          this.player.pause()
          MessageBox.alert(resp.message).then(action => {
            this.$router.push({
              path: '/login'
            })
          })
        })
      } catch (err) {
        MessageBox({
          message: '请您留意一下以下错误，反馈给客服人员：' + err,
          title: '温馨提示',
          confirmButtonText: '确定',
          confirmButtonClass: 'button'
        })
      }
    },
    startExam (retry) {
      this.startLearning()
      if (this.lessonSupervisedInfo.beginExamPicture) {
        this.learingSupervised('ONEND')
      } else {
        this.goNextLesson()
      }
    },
    cancleExam () {
      this.$refs.examDialog.close()
      this.routerBack()
    },
    goNextLesson () {
      testApi.goNextLesson({
        params: {
          lessonId: this.lessonid
        }
      }).then(resp => {
        this.zhezhao = true
        const nextLessonId = resp.result
        if (resp[Const.RESP_STATUS] == Const.STATUS_OK) {
          if (nextLessonId == -1) {
            this.getQuestionList()
            // this.routerBack();
          } else {
            this.$router.push({
              path: '/course/lesson',
              query: {lessonid: nextLessonId, courseid: this.$route.query.courseid}
            })
            window.location.reload()
          }
        } else {
          Toast(resp.message)
        }
      }).catch(resp => {
        MessageBox.confirm(resp.message).then(action => {
          // location.reload()
          // TODO 临时修复bug流程
          // 监管记录补拍
          if (resp.message.indexOf('学习中') > -1) {
            this.endUploadSup = true
            this.supervisedType = 'LEARNING_FACE'
            this.supervisedFacePlayEnd()
          } else if (resp.message.indexOf('课时结束识别') > -1) {
            this.endUploadSup = true
            this.supervisedType = 'ONEND'
            this.supervisedFacePlayEnd()
          } else if (resp.message.indexOf('开始播放识别') > -1) {
            this.endUploadSup = true
            this.supervisedType = 'ONPLAY'
            this.supervisedFacePlayEnd()
          }
        })
      })
    },
    getQuestionList (retry) {
      this.$refs.myDialog.close()
      let params = {
        lessonid: this.lessonid
      }
      if (retry) {
        params = {
          lessonid: this.lessonid,
          currentProcessStatus: retry
        }
      }
      testApi.startExam({
        params: params
      }).then(resp => {
        // console.log(resp,"接口返回的原始题目数据")
        // 对判断题进行数据清洗，仅保留ab选项 start
        let questionArr = resp.result.questionListJsonList
        for (let index in questionArr) {
          if (questionArr[index].questiontype == 'TRUEORFALSE') {
            delete questionArr[index].optionc
            delete questionArr[index].optiond
          }
        }
        // 对判断题进行数据清洗，仅保留ab选项 end

        const result = resp.result.questionListJsonList || []
        const examProgress = resp.result.currentExamProgress
        this.testId = resp.result.testId
        let questionList = []
        if (resp[Const.RESP_STATUS] == Const.STATUS_OK) {
          if (examProgress != null && examProgress.retryTime > 2) {
            let msgTips = Toast('已超过3次答题，请重新学习')
            setTimeout(() => {
              msgTips.close()
              this.initLesson()
            }, 2000)
          }
          if (result.length == 0) {
            let msgTips = Toast('此课程下无试题,请联系管理员添加试题')
            setTimeout(() => {
              msgTips.close()
              this.initLesson()
            }, 2000)
          }
          for (let i = 0; i < result.length; i++) {
            let items = []
            let r = result[i]
            if (utils.isEmptyObject(r)) {
              continue
            }
            if (r.optiona) {
              items.push({value: '1', label: r.optiona})
            }
            if (r.optionb) {
              items.push({value: '2', label: r.optionb})
            }
            if (r.optionc) {
              items.push({value: '3', label: r.optionc})
            }
            if (r.optiond) {
              items.push({value: '4', label: r.optiond})
            }
            questionList.push({
              index: i,
              questionid: r.questionid,
              content: r.content,
              questiontype: r.questiontype,
              items: items
            })
          }
          this.questionList = questionList
          this.questionInfo = this.questionList[0]
          if (this.questionInfo.questiontype = 'MULTISELECT') {
            this.questionNos[0] = []
          }
          this.$refs.examDialog.open()
        } else {
          Toast(resp.msg)
        }
      }).catch(resp => {
        Toast(resp.msg)
      })
    },
    getMenu () {
      this.videoHeadInfoDisplayInline()
      this.activeButton = 'menu'
      this.$router.push({
        path: '/index/menuPage',
        query: {courseid: this.$route.query.courseid, lessonid: this.$route.query.lessonid}
      })
    },
    getQuestion () {
      this.videoHeadInfoDisplayNone()
      if (this.logined) {
        this.activeButton = 'question'
        this.introOpen = false
        this.playAble = false
      } else {
        utils.save('USER_TYPE', 'TOURIST')// 用户类型-游客
        MessageBox.confirm('您还没有登录,现在要登录吗?').then(action => {
          this.$router.push({path: '/login'})
        })
      }
    },
    audioPlay () {
      this.activeButton = 'audio'
      this.introOpen = true
      this.playerOptions.sources[0].src = this.lesson.audiourl
      this.playerOptions.notSupportedMessage = '该课程暂无音频'
      this.playerOptions.poster = audioJpg
      this.isAudio = true
      this.playAble = true
      this.initVideoPlayer()
      Toast('音频课不计入有效课时！')
    },
    // 初始化播放器
    initVideoPlayer () {
      // document.getElementById("videoHeadInfo").style.display = "inline";
      this.videoHeadInfoDisplayInline()
      this.introOpen = true
      this.playerOptions.notSupportedMessage = '该课程暂无视频'
      this.activeButton = 'video'
      this.playerOptions.sources[0].src = this.lesson.videourl
      // this.playerOptions.sources[0].src = "https://v210303.qxueyou.com/video/2020/06/18/40288d1972c59bfe0172c7bc08ef1047ld_.m3u8?auth_key=1615034157-0-0-4b6bd287a840abe075b61372f26281f8&timestamp=1615012557513"
      this.isAudio = false
      this.playAble = true
      this.zhezhao = true
    },
    initVideoPlayerBor () {
      let that = this
      that.isplay = 1
      let winWidth = $(window).width()
      let winHeight = $(window).height()
      var video = $('.vjs-tech')
      // alert(video.val())
      video.removeAttr('x5-playsinline')
      // $(".video-js").css({"position":"absolute"})
      // video.attr('x5-video-player-type',"h5");
      // video.attr('x5-video-player-fullscreen',"true");
      // video.attr('x5-video-orientation',"portrait");
      if (!$('#back')) {
      } else {
        $('.vjs-control-bar').append('' +
            '<button id="back" ' +
            'style="background-image: url("static/images/icon/back.png");" ' +
            'class="vjs-back-control vjs-control vjs-button" ' +
            'type="button" title="Pause" ' +
            'aria-disabled="false">' +
            '<span aria-hidden="true" class="vjs-icon-placeholder"></span>' +
            '<span class="vjs-control-text" aria-live="polite">Pause</span>' +
            '</button>' +
            '<button id="forward" class="vjs-forward-control vjs-control vjs-button" ' +
            'type="button" title="Pause" aria-disabled="false">' +
            '<span aria-hidden="true" class="vjs-icon-placeholder"></span>' +
            '<span class="vjs-control-text" aria-live="polite">Pause</span>' +
            '</button>' +
            '<button id=fullscreen class="vjs-fullscreen-control vjs-control vjs-button" ' +
            'style="display: none"' +
            'type="button" title="Fullscreen" aria-disabled="false">' +
            '<span aria-hidden="true" class="vjs-icon-placeholder"></span>' +
            '<span class="vjs-control-text" aria-live="polite">Fullscreen</span>' +
            '</button>')
        // console.log(typeof($("#back")))
        // 点击后退按钮事件
        $('#back').click(function () {
          if (that.playBacktime >= that.player.currentTime()) {
          } else {
            that.playBacktime = that.player.currentTime()
          }
          console.log(that.playBacktime)
          console.log(that.player.currentTime())
          console.log(backtime)
          let backtime = 0
          if (that.player.currentTime() - 30 > 2) {
            backtime = that.player.currentTime() - 30
            that.player.currentTime(backtime)
          }
        })
        // 点击快进按钮事件
        $('#forward').click(function () {
          if (that.playBacktime <= that.player.currentTime()) {
          } else {
            that.player.currentTime(that.playBacktime)
          }
        })
        // 点击全屏按钮事件pdf-file-box
        $('#fullscreen').click(function () {
          if ($('.video-js').css('transform') == 'none') {
            $('.header').css({'display': 'none'})
            $('#foot_nav').css({'display': 'none'})
            $('.pdf-file-box').css({'display': 'none'})
            // $(".vjs-tech").css({"z-index":"10000"})
            video.css({'background-color': '#fff'})
            $('.video-js').css({'transform': 'rotate(90deg)'})
            $('.video-js').css({'width': winHeight})
            $('.video-js').css({'height': winWidth})
            $('.vjs-control-bar').css({'width': winHeight})
            // $(".video-js").css({"position":"fixed"})
            // $(".video-js").css({"z-index":2005})
            video.css({'width': winHeight})
            video.css({'height': winWidth})
          } else {
            $('.header').css({'display': ''})
            $('#foot_nav').css({'display': ''})
            $('.pdf-file-box').css({'display': ''})
            video.css({'background-color': ''})
            $('.video-js').css({'transform': ''})
            $('.video-js').css({'width': ''})
            $('.video-js').css({'height': ''})
            $('.vjs-control-bar').css({'width': ''})

            // $(".video-js").css({"position":"fixed"})
            // $(".video-js").css({"z-index":2005})
            video.css({'width': ''})
            video.css({'height': ''})
          }
        })
      }
    },
    onPlayerPlay (player) {
    },
    onPlayerPlaya () {
      // 学校归于地区吉林地区则进行上报
      if (this.lessonSupervisedInfo.ancestors && this.lessonSupervisedInfo.ancestors.indexOf('0,15276,614456') > -1) {
        this.courseReport()
      }

      this.modifyPlayBacktime('report')

      localStorage.setItem('inPlayerPlaya', 'true')
      if ($('.vjs-control-bar').length == 0) {
        localStorage.setItem('not_vjscontrolbar', 'true')
        MessageBox.alert('视频正在努力加载，请稍后重试')
      } else {
        localStorage.setItem('is_vjscontrolbar', 'true')
        this.initVideoPlayerBor()
        localStorage.setItem('initVideoPlayerBor', 'true')
        this.startLearning()
        localStorage.setItem('startLearning', 'true')
        this.playerOptions.poster = audioJpg
        if (this.lesson.stage === 'EXAMINATION') {
          this.finish = true
          this.startExam()
        } else if (this.lesson.stage === 'DISABLED') {
          this.routerBack()
        }
        // 1分钟内不触发ONPLAY 监管
        let onFaceCheck = new Date().getTime() - utils.get('onFaceCheck' + this.$route.query.lessonid + '' + this.$route.query.courseid)
        console.log(onFaceCheck)
        // 开始播放监管
        console.log(this.supervisedResult.compareResult)
        console.log(this.supervisedType.indexOf('LEARNING'))
        localStorage.setItem('beforeLearingSupervised', 'true')
        if (!this.supervisedResult.compareResult && this.supervisedType.indexOf('LEARNING') === -1 && onFaceCheck > 1000 * 60 * 1) {
          localStorage.setItem('beforeONPLAY', 'true')
          this.learingSupervised('ONPLAY')
        } else {
          localStorage.setItem('beforeplay', 'true')
          this.zhezhao = false
          this.player.play()
        }
      }
    },
    onPlayerAudioPlay (player) {
      if (this.lesson.stage === 'EXAMINATION') {
        player.pause()
        this.finish = true
        this.startExam()
      } else if (this.lesson.stage === 'DISABLED') {
        player.pause()
        this.routerBack()
      }
      console.log('这是要从哪里开始播放呢?', this.currentTime)
      player.target.currentTime = this.currentTime
    },
    onPlayerEnded (player) {
      if (this.logined) {
        if (this.lesson.stage === 'CONTINUE' ||
                        this.lesson.stage === 'ADDLEARN' ||
                        this.lesson.stage === 'MISSLEARN' ||
                        this.lesson.stage === 'OVERTIMELEARN') {
          // this.finish = true
          this.finishTag = true
          this.modifyPlayBacktime()
          this.playAble = false
          this.$refs.myDialog.open()
        }
      }
    },
    onPlayerError (player) {
      console.log('播放失败了')
      this.playerOptions.notSupportedMessage = '媒体资源不存在或无法解析'
      // this.playerOptions.sources[0].src = ''
    },
    onPlayerTimeAudioupdate (player) {
      let playTime = player.target.currentTime
      console.log('当前的播放时间获取异常', playTime)
      if (this.logined) {
        if (this.lesson.stage === 'CONTINUE') {
          if (playTime - this.currentTime > 5 || playTime - this.currentTime < -10) {
            player.target.currentTime = this.currentTime
          } else {
            console.log('播放时间更新了', this.currentTime, playTime)
            this.currentTime = playTime
            if (this.currentTime - 0 - this.playBacktime > 60) {
              this.playBacktime = this.currentTime
              this.modifyPlayBacktime()
            }
          }
        } else if (this.lesson.stage === 'FREE') {
          this.currentTime = player.target.currentTime
        }
      } else {
        this.currentTime = player.target.currentTime
      }
    },
    // 学习中监管处理，判断是否到随机监管点
    checkPlayTimeSupervised (playTime) {
      let currPlayTime = playTime
      let faceStartIndex = this.lessonSupervisedInfo.superviseFaceCounts
      let superviseLeaveTimeList = []
      // 当superviseLeaveTimeList为空时，不进行赋值
      if (this.lessonSupervisedInfo.superviseLeaveTimeList) {
        superviseLeaveTimeList = this.lessonSupervisedInfo.superviseLeaveTimeList.split(',')
      }
      if (this.lessonSupervisedInfo.randomTestTimeList) {
        this.randomTestTimeList = this.lessonSupervisedInfo.randomTestTimeList.split(',')
      }
      let leaveStartIndex = this.lessonSupervisedInfo.superviseLeaveCounts

      // 课程监管规则（固定监管及随机监管）
      for (let i = 0; i < this.lessonSupervisedInfo.regulationNodeList.length; i++) {
        if (this.lesson.indexOrder === this.lessonSupervisedInfo.regulationNodeList[i].course) {
          let supTimes = parseInt(this.lesson.medialength * this.lessonSupervisedInfo.regulationNodeList[i].trigger / 1000 / 100)
          console.log('监管时间点：' + supTimes)
          if (parseInt(currPlayTime) >= supTimes) {
            if (!this.checkPlayTimeSupervisedOning) {
              // alert("需要进行身份验证，请调用摄像头拍摄真实头像，否则学习记录无效！:" + parseInt(parseInt(superviseFaceTimeList[j]) / 1000))
              if (this.isAndroid) {
                this.zhezhao = true
              }
              this.nodeIndex = i
              this.learingSupervised(this.lessonSupervisedInfo.regulationNodeList[i].learningSupervisedType)
            }
            // this.lessonSupervisedInfo.regulationNodeList[i].trigger = 110
            // 记录监管状态，防止二次触发
            this.checkPlayTimeSupervisedOning = true
            break
          }
        }
      }
      // 判断是否是监管非教学时间及目前处理教学时间监管
      if (!this.reviewFlag && this.lessonSupervisedInfo.nonTeachingSuperviseFlag) {
        // 时间累积加上非教学时间
        playTime = playTime * 1000 + this.lessonSupervisedInfo.lessonLimitDuration - this.lessonSupervisedInfo.lessonMediaDuration
        playTime = playTime / 1000
      }
      // 更改逻辑，增加人社设置监管规则
      for (let i = 0; i < this.lessonSupervisedInfo.learningSuperviseds.length; i++) {
        let learningSupervised = this.lessonSupervisedInfo.learningSuperviseds[i]
        let superviseFaceTimeList = []
        if (learningSupervised.superviseFaceTimes) {
          superviseFaceTimeList = learningSupervised.superviseFaceTimes.split(',')
        }
        for (let j = 0; j < superviseFaceTimeList.length; j++) {
          // 当前播放时间大于监管时间，调用监管
          if (parseInt(playTime) >= parseInt(parseInt(superviseFaceTimeList[j]) / 1000)) {
            console.log(playTime)
            this.player.pause()
            this.popupVisible = true
            this.lessonSupervisedInfo.currentSuperviseFaceTime = superviseFaceTimeList[j]
            console.log('调用A：learingSupervised')
            if (!this.checkPlayTimeSupervisedOning) {
              // alert("需要进行身份验证，请调用摄像头拍摄真实头像，否则学习记录无效！:" + parseInt(parseInt(superviseFaceTimeList[j]) / 1000))
              if (this.isAndroid) {
                this.zhezhao = true
              }
              this.learingSupervised(learningSupervised.supervisedType)
            }
            // 记录监管状态，防止二次触发
            this.checkPlayTimeSupervisedOning = true
            break
          }
        }
      }
      // 离线监管
      for (let i = leaveStartIndex; i < superviseLeaveTimeList.length; i++) {
        if (parseInt(playTime) == parseInt(parseInt(superviseLeaveTimeList[i]) / 1000)) {
          console.log('调用B：learingSupervised')
          this.learingSupervised('LEARNING_LEAVE')
          break
        }
      }
      // 随机弹出测试题-------------------------
      for (let i = 0; i < this.randomTestTimeList.length; i++) {
        console.log('-------------------')
        if (parseInt(playTime) >= parseInt(parseInt(this.randomTestTimeList[i]) / 1000)) {
          // let supTimes = parseInt(this.lesson.medialength * this.lessonSupervisedInfo.regulationNodeList[i].trigger / 1000 / 100);
          this.player.pause()
          if (this.isAndroid) {
            this.zhezhao = true
          }
          let questionList2 = []
          if (true) {
            this.questionList2 = []
            this.questionInfo2 = {}
            let i2 = 3 - this.randomTestTimeList.length
            let items2 = []
            let r = this.lessonSupervisedInfo.questionListJsonList[i2]
            if (utils.isEmptyObject(r)) {
              continue
            }
            if (r.optiona) {
              items2.push({value: '1', label: r.optiona})
            }
            if (r.optionb) {
              items2.push({value: '2', label: r.optionb})
            }
            if (r.optionc) {
              items2.push({value: '3', label: r.optionc})
            }
            if (r.optiond) {
              items2.push({value: '4', label: r.optiond})
            }
            questionList2.push({
              index: 0,
              questionid: r.questionid,
              content: r.content,
              questiontype: r.questiontype,
              items2: items2
            })
            this.questionList2 = questionList2
            this.questionInfo2 = this.questionList2[0]
            this.$refs.examDialog2.open()
          }
          break
        }
      }
    },

    onPlayerTimeupdate (player) {
      try {
        this.playTimeTemp = player.currentTime()
        if (this.logined) {
          if (this.lesson.stage === 'CONTINUE' ||
                            this.lesson.stage === 'ADDLEARN' ||
                            this.lesson.stage === 'MISSLEARN' ||
                            this.lesson.stage === 'OVERTIMELEARN') {
            console.log('curr player Progress :' + this.playTimeTemp + ', vod medialength : ' + this.lesson.medialength / 1000)
            // 到达视频时长，则显示【进入下一章】弹窗
            if (Math.floor(this.lesson.medialength / 1000) - Math.floor(this.playTimeTemp) < 2) {
              console.log('go next lesson alert')
              this.finishTag = true
              // 判读下是不是快进触发的
              if (Math.floor(this.playTimeTemp) - Math.floor(this.currentTime) > 20) {
                this.finishTag = false
                return
              }
              this.modifyPlayBacktime()
              this.playAble = false
              this.$refs.myDialog.open()
              return
            }
            this.checkPlayTimeSupervised(this.playTimeTemp)
            // 限制到180秒，后台判断
            // 限制10s执行一次同步
            // 首次init获取时间乱序，则同步执行下一步
            if (Math.floor(this.playTimeTemp) % 2 === 0) {
              if (this.currentTime === -1) {
                this.currentTime = this.getPlayBacktime().then(function (res) {
                  if (this.isplay == 1) {
                    this.isplay = 0
                    player.currentTime(this.currentTime)
                  }
                  // 检测是否到达监管时间
                  this.currentTime = this.playTimeTemp
                  if (Math.floor(this.currentTime) - Math.floor(this.playBacktime) > 60) {
                    this.playBacktime = this.currentTime
                    this.modifyPlayBacktime()
                  }
                })
              } else {
                if (this.isplay == 1) {
                  this.isplay = 0
                  player.currentTime(this.currentTime)
                }
                // 检测是否到达监管时间
                this.currentTime = this.playTimeTemp
                console.log('临时时间：' + this.playTimeTemp)
                console.log('当前播放时间' + this.currentTime)
                console.log('后台播放时间' + this.playBacktime)
                if (Math.floor(this.currentTime) - Math.floor(this.playBacktime) > 60) {
                  this.playBacktime = this.currentTime
                  console.log('到监管时间后台播放时间' + this.playBacktime)
                  this.modifyPlayBacktime()
                }
              }
            }
          } else if (this.lesson.stage === 'FREE') {
            this.currentTime = player.currentTime()
          }
        } else {
          this.currentTime = player.currentTime()
        }
      } catch (err) {
        MessageBox({
          message: err,
          title: '温馨提示',
          confirmButtonText: '确定',
          confirmButtonClass: 'button'
        })
      }
    },
    send () {
      api.addMyQuestion({
        params: {
          content: this.questionInput,
          lessonId: this.lessonid
        }
      }).then(resp => {
        // Toast('提交成功,请等待管理员审核')
        this.getMyAnswerList()
        this.questionInput = ''
      }).catch(resp => {
        Toast(resp.message)
      })
    },
    getMyAnswerList () {
      api.getMyAnswerList({
        params: {
          pageno: this.myAnswerList.pageNo,
          pagesize: this.myAnswerList.pageSize
        }
      }).then(resp => {
        var list = resp.result
        if (list || list.length > 0) {
          for (let i in list) {
            if (list[i].senderid === this.userId) {
              list[i].flag = 'question'
            } else {
              list[i].flag = 'answer'
            }
          }
          if (this.myAnswerList.list.length % 10 !== 0) {
            this.allLoaded = true
            this.myAnswerList.list = list.reverse()
            console.log('需要渲染的数据为', this.myAnswerList.list)
          } else {
            this.myAnswerList.list = list.reverse()
          }
        }
      })
    },
    loadTop () {
      this.myAnswerList.pageSize += 10
      this.getMyAnswerList()
      this.$refs.loadMore.onTopLoaded()
    },
    // 开始播放-音频
    play () {
      var audio = document.querySelector('#audio')
      audio.play()
      this.playflg = true
      this.offset = parseInt(audio.duration)
      console.log('开始播放-时长=' + audio.duration)
      console.log(Math.ceil(this.offset))
      if (this.playflg = true) {
        var timer = setInterval(() => {
          var min = '0' + parseInt(audio.currentTime / 60)
          var max = parseInt(audio.duration)
          var sec = parseInt(audio.currentTime % 60)
          if (sec < 10) {
            sec = '0' + sec
          }
          this.starttime = min + ':' + sec /*  00:00  */
          this.rangeValue = parseInt(audio.currentTime)
          if (this.rangeValue == this.offset) {
            this.rangeValue = 0/* 播放结束后进度条归零 */
            this.starttime = '00:00' /* 播放结束后时间归零 */
            this.stop()
            clearInterval(timer)
          }
        }, 1000)
      }
    },
    // 暂停-结束-音频
    stop () {
      var audio = document.querySelector('#audio')
      audio.pause()
      this.playflg = false
      console.log('暂停播放')
    },
    initWebSocket () { // 初始化weosocket
      const wsuri = 'wss://websocket.sdjtip.com/api/sendMSG'
      this.myWebsock = new WebSocket(wsuri)
      this.myWebsock.onmessage = this.websocketonmessage
      this.myWebsock.onopen = this.websocketonopen
      this.myWebsock.onerror = this.websocketonerror
      this.myWebsock.onclose = this.websocketclose
    },
    websocketonopen () { // 连接建立之后执行send方法发送数据
      console.log('socket 上报数据')
      // this.websocketsend(JSON.stringify({'type': 'first', 'techerId': this.lessonSupervisedInfo.studentId}))
      this.websocketsend(JSON.stringify({
        'groupId': this.lessonSupervisedInfo.groupId,
        'memberId': this.lessonSupervisedInfo.studentId
      }))
    },
    websocketonerror () { // 连接建立失败重连
      this.initWebSocket()
    },
    websocketonmessage (e) { // 数据接收
      console.log(e.data)
      this.supervisedType = 'MANUAL_SUPERVISION'
      this.manualSupervisionId = e.data
      console.log('MANUAL_SUPERVISION')
      this.supervisedFace()
      // 3s后关闭模态框
      setTimeout(function () {
        this.popupVisible = false
      }, 60000)
    },
    websocketsend (Data) { // 数据发送
      this.myWebsock.send(Data)
    },
    websocketclose (e) { // 关闭
      console.log('断开连接', e)
    },
    websocketClose () { // 关闭
      this.myWebsock.close()
      console.log('自动断开websocket连接')
    },
    checkCanOnlineStudy4Student () {
      supervisedApi.checkCanOnlineStudy4Student({
        params: {groupId: this.lessonSupervisedInfo.groupId}
      }).then(resp => {
        var data = resp.result
        if (!data) {
          MessageBox({
            title: '',
            message: '还未到学习时间,请参照班期学习时间进行学习',
            confirmButtonText: '返回首页',
            confirmButtonClass: 'button'
          }).then(action => {
            this.$router.push({path: '/index'})
          })
        }
      })
    },
    set_ALY_config () {
      let _this = this
      AWSC.use('ic', function (state, module) {
        // 初始化
        window.ic = module.init({
          // 应用类型标识。它和使用场景标识（scene字段）一起决定了智能验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
          appkey: 'FFFF0N0N00000000A446',
          // 使用场景标识。它和应用类型标识（appkey字段）一起决定了智能验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的scene值，请务必正确填写。
          scene: 'ic_activity',
          // 声明智能验证需要渲染的目标元素ID。
          renderTo: 'sc',
          // 验证通过时会触发该回调参数。您可以在该回调参数中将会话ID（sessionId）、签名串（sig）、请求唯一标识（token）字段记录下来，随业务请求一同发送至您的服务端调用验签。
          success: function (data) {
            window.console && console.log(data.sessionId)
            window.console && console.log(data.sig)
            window.console && console.log(data.token)
            _this.popupVisiblesc = false
            _this.captchareset()
            _this.chkdskCaptcha(data.sessionId, data.sig, data.token)
          },
          // 验证失败时触发该回调参数
          fail: function (failCode) {
            console.log(failCode)
            _this.captchareset()
          },
          // 验证码加载异常时触发该回调参数
          error: function (errorCode) {
            console.log(errorCode)
            _this.captchareset()
          }
          // 该配置项为测试项 在仅用来测试验证码不同状态时使用。上线时请将其删除. 智能验证test配置项有4种不同的值对应不同的验证码状态，具体请参考文中参数定义说明部分。
          // ,test: module.TEST_PASS, // 测试智能验证通过
          // ,test: module.TEST_BLOCK, // 测试智能验证失败
          // ,test: module.TEST_NC_PASS, // 唤醒滑动验证并验证通过
          // ,test: module.TEST_NC_BLOCK, // 唤醒滑动验证并验证失败
        })
      })
    },
    captchareset () {
      window.ic.reset()
    },

    chkdskCaptcha (sessionId, sig, token) {
      var params = {
        sessionId: sessionId,
        sig: sig,
        token: token,
        scene: 'ic_activity_h5'
      }
      api.chkdskCaptcha({
        params: params
      }).then(resp => {
        // 设置返回编码含义100验签通过,200直接通过,400前端弹出nc,600前端弹出sc,700前端弹出lc,800直接拦截,900验签失败 999-账户限制使用 1 -无需验证
        if (resp.result != 100 && resp.result != 200 && resp.result != 1) {
          this.player.pause()
          MessageBox.alert(resp.result + ' 数异常，请重新登录').then(action => {
            this.$router.push({
              path: '/login'
            })
          })
        }
      }).catch((resp) => {
        this.player.pause()
        MessageBox.alert(resp.message).then(action => {
          this.$router.push({
            path: '/login'
          })
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/view/index/course/lesson.vue